import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as yup from 'yup';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

interface ICarrierContext {
    isLoading: boolean
    carrier: Carrier

    saveCarrier: (carrier: Carrier) => void
}

export let carrierSchema = yup.object({
    id: yup.string().nullable().default(null),
    carrierCode: yup.string().required().default('').label('Carrier code'),
    trackingUrl: yup.string().required().default('').label('Tracking url'),
});

type Carrier = yup.InferType<typeof carrierSchema>;

export let carrierContext = React.createContext({} as ICarrierContext);

let { Provider } = carrierContext;

let CarrierProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let location = useLocation();
    let navigate = useNavigate();
    let { enqueueSnackbar } = useSnackbar();

    let isNew = location.pathname.includes("/addnew");

    let [isLoading, setLoading] = useState<boolean>(isNew === false);
    let [carrier, setCarrier] = useState<Carrier>(carrierSchema.getDefault());
    let [isSaving, setSaving] = useState(false);


    useEffect(() => {
        if (isNew === false)
            getCarrier();

    }, [id, isNew])

    let getCarrier = async () => {
        try {
            let res = await axios.get('/api/Carrier/GetCarrier', { params: { id } });

            let { item } = res.data;
            setCarrier({
                ...item,
            });
            setLoading(false);

        } catch (err) { }
        finally {
        }
    }

    let saveCarrier = async (value: Carrier) => {
        try {
            await axios.post('/api/Carrier/SaveCarrier', value);
            enqueueSnackbar("Carrier saved", { variant: "success" });
            navigate(`/admin/carrier`);

        } catch (err) {
            setSaving(false)
        }
    }

    return (
        <Provider
            value={{
                isLoading,
                carrier,

                saveCarrier
            }}
        >
            {children}
        </Provider>
    )
}

export default CarrierProvider;